// ** React Imports
import { useContext } from "react";

// ** Third Party Components
import { useTranslation } from "react-i18next";

// ** Custom Components
import Block from "components/layout/Block";
import SelectorSelectSingle from "components/layout/DropdownSelectors/SelectorSelectSingle";
import Tooltip from "components/layout/Tooltip";
import { ButtonSecondary } from "components/layout/Button/ButtonSecondary";
import { ButtonProfileAction } from "components/layout/Button/ButtonProfileAction";
import { Icon } from "components/icons";

// ** Contexts
import deviceTypeContext from "contexts/deviceTypeContext";

// ** Styles
import { StyledActionsContainer } from "./styles/ActionsContainer.styled";

// #####################################################

const ActionsComponent = ({
	actionItems,
	isActionMenuVisible,
	setActionMenuVisibility,
}) => {
	const { t } = useTranslation(["common"]);
	const { isPhone } = useContext(deviceTypeContext);

	const actionItemsFirst = actionItems.filter(
		({ inDropdown }) => inDropdown !== true,
	);

	const actionItemsInDropdown = actionItems.filter(
		({ inDropdown }) => inDropdown === true,
	);

	return (
		((isPhone && isActionMenuVisible) || !isPhone) && (
			<StyledActionsContainer>
				{actionItemsFirst.map((item) => {
					const BtnComponent = isPhone ? (
						<ButtonProfileAction
							key={`actionItemsFirst-${item.label}`}
							onlyBorder
							active={
								typeof item.isActive === "function"
									? item.isActive()
									: false
							}
							{...item}
							style={{
								fontSize: "11px",
								lineHeight: "15px",
								padding: "0.5rem",
							}}
							onClick={(event) => item.action(event)}
							iconSize="1.5em"
						/>
					) : (
						<ButtonSecondary
							key={`actionItemsFirst-${item.label}`}
							active={
								typeof item.isActive === "function"
									? item.isActive()
									: false
							}
							textLeft
							{...item}
							onClick={(event) => item.action(event)}
							iconSize="0.85em"
						/>
					);

					return item.disabled ? (
						<Tooltip
							text={item.tooltip}
							key={`actionItemsFirst-tooltip-${item.label}`}
						>
							{BtnComponent}
						</Tooltip>
					) : (
						BtnComponent
					);
				})}
				{actionItemsInDropdown && actionItemsInDropdown.length > 0 && (
					<>
						{isPhone ? (
							actionItemsInDropdown.map((item) => {
								return item.disabled ? (
									<Tooltip
										text={item.tooltip}
										key={`actionItemsInDropdown-tooltip-${item.label}`}
										label={item.label}
									>
										<ButtonProfileAction
											key={`actionItemsInDropdown-botton-${item.label}`}
											noMargin
											{...item}
											onClick={(event) => {
												setActionMenuVisibility(false);
												item.action(event);
											}}
											style={{
												fontSize: "11px",
												lineHeight: 1,
												padding: isPhone
													? "0.5rem"
													: undefined,
											}}
											iconSize="1.5em"
										/>
									</Tooltip>
								) : (
									<ButtonProfileAction
										key={`actionItemsInDropdown-botton-${item.label}`}
										textLeft
										noMargin
										{...item}
										onClick={(event) => {
											setActionMenuVisibility(false);
											item.action(event);
										}}
										style={{
											fontSize: "11px",
											lineHeight: "15px",
											padding: "0.5rem",
										}}
										iconSize="1.5em"
									/>
								);
							})
						) : (
							<SelectorSelectSingle
								minWidth
								noMaxWidth
								withBorderTop
								selectorKey="showMoreActionsSelector"
								emptyText={t("common:any.3")}
								items={actionItemsInDropdown.map((item) => {
									return {
										key: `showmore-selector-${
											item.key || item.label
										}`,
										content: item.label,
										...item,
										onClick: (event) => {
											if (item.disabled !== true) {
												item.action(event);
											}
										},
									};
								})}
								customActivator={({ innerRef, toggle }) => (
									<ButtonSecondary
										iconOnly
										iconNew={<Icon name="ellipsis-h" />}
										icon="ellipsis-h"
										innerRef={innerRef}
										onClick={toggle}
									/>
								)}
								customDropdownList={({ items }) => (
									<Block
										flex
										column
										px={4}
										py={3}
										withRowGap="0.75rem"
										style={{ width: "max-content" }}
									>
										{items.map((item) => {
											return item.disabled ? (
												<Tooltip
													text={item.tooltip}
													key={`actionItemsInDropdown-tooltip-${item.label}`}
													label={item.label}
												>
													<ButtonSecondary
														key={`actionItemsFirst-${item.label}`}
														block
														active={
															typeof item.isActive ===
															"function"
																? item.isActive()
																: false
														}
														textLeft
														{...item}
														onClick={(event) =>
															item.action(event)
														}
														iconSize="0.85em"
													/>
												</Tooltip>
											) : (
												<ButtonSecondary
													key={`actionItemsFirst-${item.label}`}
													active={
														typeof item.isActive ===
														"function"
															? item.isActive()
															: false
													}
													textLeft
													{...item}
													onClick={(event) =>
														item.action(event)
													}
													iconSize="0.85em"
												/>
											);
										})}
									</Block>
								)}
								customLayerStyle={{
									borderTopRightRadius: "0",
									borderTopLeftRadius: "0",
									borderBottomRightRadius: "1.25rem",
									borderBottomLeftRadius: "1.25rem",
								}}
								useLayerOptions={{
									overflowContainer: false,
									triggerOffset: 9,
									placement: "bottom-end",
								}}
							/>
						)}
					</>
				)}
			</StyledActionsContainer>
		)
	);
};

// #####################################################

export default ActionsComponent;

// #####################################################
